import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconZoomIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconZoomIn"><Path fillRule="evenodd" clipRule="evenodd" d="M3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.9385 18.3098 14.7169 17.1628 16.1012L21.0612 19.9996L20.0005 21.0602L16.1023 17.162C14.7178 18.3094 12.939 19 11 19C6.58172 19 3 15.4183 3 11ZM11.75 10.25V7H10.25V10.25H7V11.75H10.25V15H11.75V11.75H15V10.25H11.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconZoomIn;
